import checkoutInfo from "./slice";

export default checkoutInfo.reducer;

export const { clearOrderData, setOrderData, loadOrderData } = checkoutInfo.actions;
